// extracted by css-extract-rspack-plugin
export default {"controls":"Block-module__controls___M22Xt"};